import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import useAuth from "../../contexts/UserContext.tsx";
import axiosInstance from "../../Axios";
import { DataGrid } from "@mui/x-data-grid";
import { toast } from "sonner";

const columns = [
  {
    field: "fname",
    headerName: "First name",
    width: 150,
  },
  {
    field: "lname",
    headerName: "Last name",
    width: 150,
  },
  {
    field: "school_name",
    headerName: "School name",
    width: 150,
  },
  {
    field: "district",
    headerName: "District name",
    width: 150,
  },
  {
    field: "marks",
    headerName: "Marks",
    width: 150,
  },
];

export default function TopStudents() {
  const { user } = useAuth();
  var school_types_array = user.view_access_list.school_types.split(",");
  //Remove the duplicate values from the array
  school_types_array = school_types_array
    .filter((value, index, self) => self.indexOf(value) === index)
    .map((schoolType) => schoolType.replace(/['"]+/g, ""))
    .sort();
  var district_array = user.view_access_list.district.split(",");
  //Remove the duplicate values from the array
  district_array = district_array
    .filter((value, index, self) => self.indexOf(value) === index)
    .map((district) => district.replace(/['"]+/g, ""))
    .sort();
  const [selectedSchoolTypes, setSelectedSchoolTypes] =
    useState(school_types_array);
  const [selectedDistricts, setSelectedDistricts] = useState(district_array);
  const [, setLoading] = useState(false);
  const [, setSelectedSchoolString] = useState(
    selectedSchoolTypes.map((word) => `'${word}'`).join(",")
  );
  const [, setSelectedDistrictString] = useState(
    selectedDistricts.map((word) => `'${word}'`).join(",")
  );
  const [topStudentsData, setTopStudentsData] = useState([]);

  const clickFilterHandler = async () => {
    const school_str = selectedSchoolTypes.map((word) => `'${word}'`).join(",");
    const district_str = selectedDistricts.map((word) => `'${word}'`).join(",");
    setSelectedSchoolString(school_str);
    setSelectedDistrictString(district_str);
    try {
      setLoading(true);
      const res = await axiosInstance.post("/getTopStudentsInDistrict", {
        user_id: user.user_id,
        auth_token: user.auth_token,
        school_types: school_str,
        district_names: district_str,
      });
      setTopStudentsData(res.data.data.top_students);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    clickFilterHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="teacher-form-container flex gap-2 pt-2 mb-4">
        <FormControl fullWidth>
          <InputLabel id="checkbox-dropdown-label">School Types</InputLabel>
          <Select
            labelId="checkbox-dropdown-label"
            id="checkbox-dropdown"
            multiple
            label="School Types"
            value={selectedSchoolTypes}
            onChange={() => {}}
            renderValue={(selected) => [...selected].join(", ")}
          >
            <MenuItem
              key="select-all"
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedSchoolTypes(school_types_array);
                } else {
                  setSelectedSchoolTypes([]);
                }
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    indeterminate={
                      selectedSchoolTypes.length > 0 &&
                      selectedSchoolTypes.length < school_types_array.length
                    }
                    checked={
                      selectedSchoolTypes.length === school_types_array.length
                    }
                  />
                }
                label="Select All"
              />
            </MenuItem>
            {school_types_array.map((option) => (
              <MenuItem key={option} value={option}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedSchoolTypes.includes(option)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedSchoolTypes([
                            ...selectedSchoolTypes,
                            option,
                          ]);
                        } else {
                          setSelectedSchoolTypes(
                            selectedSchoolTypes.filter(
                              (type) => type !== option
                            )
                          );
                        }
                      }}
                    />
                  }
                  label={option}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id="checkbox-dropdown-label">District</InputLabel>
          <Select
            labelId="checkbox-dropdown-label"
            id="checkbox-dropdown"
            multiple
            label="Districts"
            value={selectedDistricts}
            onChange={() => {}}
            renderValue={(selected) => [...selected].join(", ")}
          >
            <MenuItem
              key="select-all"
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedDistricts(district_array);
                } else {
                  setSelectedDistricts([]);
                }
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    indeterminate={
                      selectedDistricts.length > 0 &&
                      selectedDistricts.length < district_array.length
                    }
                    checked={selectedDistricts.length === district_array.length}
                  />
                }
                label="Select All"
              />
            </MenuItem>
            {district_array.map((option) => (
              <MenuItem key={option} value={option}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedDistricts.includes(option)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedDistricts([...selectedDistricts, option]);
                        } else {
                          setSelectedDistricts(
                            selectedDistricts.filter((type) => type !== option)
                          );
                        }
                      }}
                    />
                  }
                  label={option}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <button
          onClick={clickFilterHandler}
          className="bg-blue-500 rounded-md hover:bg-blue-700 w-[250px] text-white"
        >
          Submit
        </button>
      </div>
      <DataGrid
        columns={columns}
        rows={topStudentsData}
        pageSize={25}
        pagination
        disablePageSize
        rowHeight={50}
        sx={{ marginTop: "0.5em" }}
        autoHeight={true}
        getRowId={(row) => row.id}
        // components={{
        //   Toolbar: CustomToolbarCourses,
        // }}
        // onSelectionModelChange={handleAddCourseSelectionChange}
      />
      ;
    </>
  );
}
